import React, { useContext, useEffect, useState } from "react";
import { Button, Skeleton, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import { PlusOutlined } from "@ant-design/icons";
import CategoryForm from "./CategoryForm";
import { getCategoryApi } from "../../../../services/service.services";
import CategoryTable from "./CategoryTable";
import { UserContext } from "../../../../context/UserContext";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";
import { UiDataTable } from "../../../ui";
import useQuery from "../../../../hooks/useQuery";
import {
  parseSearchParam,
  updateUrlSearchParams,
} from "../../../../helpers/urlFilters";

const Categories = () => {
  const navigate = useNavigate();
  const params = useQuery();
  const searchQuery = parseSearchParam(params);
  const { userDetails } = useContext(UserContext);
  const [isVisible, setIsVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);

  const defaultRole = userDetails?.currRole || getCookie(Role);

  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };

  useEffect(() => {
    setLoading(true);
    getCategoryApi()
      .then((res) => {
        setData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [refresh]);

  useEffect(() => {
    const query = (searchQuery || "").toLowerCase();
    if (!query) {
      setFilteredData(data ?? []);
      return;
    }
    setFilteredData(
      data?.filter((category) =>
        category?.name?.toLowerCase()?.includes(query)
      ) ?? []
    );
  }, [data, searchQuery]);

  const onCategorySearch = (e) => {
    const query = e?.target?.value || "";
    updateUrlSearchParams(navigate, { search: query || null });
  };

  const showToolbar = (data?.length > 0) || Boolean(searchQuery);
  const showAddCategories =
    defaultRole !== "Facility_Admin" && defaultRole !== "Receptionist";

  return (
    <div>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          {showToolbar ? (
            <UiDataTable
              showHeader={false}
              shellClassName="ui-table-fill-shell"
              onSearch={onCategorySearch}
              searchValue={searchQuery}
              searchPlaceholder="Search category"
              toolbarTrailing={
                showAddCategories ? (
                  <Button
                    type="primary"
                    onClick={() => setIsVisible(true)}
                    className={btnStyles.lgBtn}
                  >
                    <PlusOutlined /> Categories
                  </Button>
                ) : null
              }
            >
              <CategoryTable
                data={filteredData}
                setData={setData}
                refreshPage={refreshPage}
                loading={loading}
                userDetails={userDetails}
              />
            </UiDataTable>
          ) : (
            <div className="facilities" style={{ textAlign: "center" }}>
              {defaultRole !== "Facility_Admin" ? (
                <Button
                  type="primary"
                  onClick={() => setIsVisible(true)}
                  className={btnStyles.lgBtn}
                >
                  <PlusOutlined /> Categories
                </Button>
              ) : (
                <Empty />
              )}
            </div>
          )}
        </>
      )}

      {isVisible && (
        <CategoryForm
          open={isVisible}
          setOpen={setIsVisible}
          refreshPage={refreshPage}
        />
      )}
    </div>
  );
};

export default Categories;
